<div class="comment-content-container">
    <table mat-table [dataSource]="data.comment">
        <ng-container matColumnDef="comment" >
            <th mat-header-cell *matHeaderCellDef class="roster-comment-data">Note</th>
            <td mat-cell *matCellDef="let userComment" class="roster-comment-data">{{userComment.comment}}</td>
        </ng-container>
        <ng-container matColumnDef="dateCreated">
            <th mat-header-cell *matHeaderCellDef class="comment-column-width">Date</th>
            <td mat-cell *matCellDef="let userComment" class="comment-column-width">{{userComment.dateCreated}}</td>
        </ng-container>
        <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef class="comment-column-width">Created By</th>
            <td mat-cell *matCellDef="let userComment" class="comment-column-width">{{userComment.createdByDisplayName}}</td>
        </ng-container>
        <ng-container matColumnDef="canDelete">
            <th mat-header-cell *matHeaderCellDef class="comment-column-width"></th>
            <td mat-cell *matCellDef="let userComment" class="comment-column-width">
                <div *ngIf="userComment.canDelete">
                    <app-button-list>
                        <app-button (clickedEvent)="deleteComment(userComment)" [icon]="'delete'">Delete </app-button>
                    </app-button-list>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <app-button-list>
        <app-button (clickedEvent)="onClose()" [icon]="'close'">Close </app-button>
    </app-button-list>
</div>
